export class SetSpinnerVisibility {
  static readonly type = '[Spinner Visibility] Set';

  constructor(
    public spinnerVisibility: boolean
  ) {}
}
